// @flow

export const SET_DIRTY = '@form/SET_DIRTY';

export type FormAction = {
  type: '@form/SET_DIRTY',
  dirty: boolean,
  form: string,
};

export const setDirty = (dirty: boolean, form: string): FormAction => ({
  type: SET_DIRTY,
  dirty,
  form,
});



// WEBPACK FOOTER //
// ./src/actions/form.js